import { ICON_SIZES } from "../icon/Icon";
import { LogoutModal } from "../logoutModal/LogoutModal";
import { useAuth } from "src/apps/hooks/useAuth";
import { useState } from "react";
import { IconButton } from "../icon/IconButton";
import { ICON_PATHS } from "../icon/IconSVGPaths";
import {
  AnalyticsEvents,
  useSendAnalyticEvent,
} from "src/apps/hooks/analytics/useSendAnalyticEvent";
import { colors } from "@permisso/permisso-components";

export const LogoutFlow = () => {
  const { deleteToken } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { sendEvent } = useSendAnalyticEvent();

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const confirmLogout = () => {
    closeModal();
    deleteToken();
    sendEvent(AnalyticsEvents.DOCUMENTATION_AREA_LOGGED_OUT);
  };

  return (
    <div>
      <IconButton
        size={ICON_SIZES.s20}
        color={colors.grey700}
        path={ICON_PATHS.LOGOUT_ICON}
        onClick={openModal}
      />
      {isModalOpen ? (
        <LogoutModal onClose={closeModal} isOpen={isModalOpen} onConfirm={confirmLogout} />
      ) : null}
    </div>
  );
};
